'use client';

import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { RockerLogo } from '../media/rocker';
import { BagLogo } from '../media/bag';
import { HandLogo } from '../media/hand';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Map feature types to their respective logos
const featureLogos = {
  innovative: RockerLogo,
  strategic: BagLogo,
  community: HandLogo,
};

export default function Features() {
  const { currentLanguage, isRTL } = useLanguage();
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const res = await fetch('/api/features');
        if (!res.ok) {
          throw new Error('Failed to fetch features');
        }
        const data = await res.json();
        setFeatures(data.features || []);
      } catch (error) {
        console.error('Error fetching features:', error);
        setFeatures([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatures();
    AOS.init({ duration: 1000 });
  }, []); // Run once on mount

  if (loading) {
    return null; // Or a loading spinner
  }

  if (!features || features.length === 0) {
    return null;
  }

  return (
    // Features Section
    <section className="w-full bg-white">
      <div className="w-full px-[4%] sm:px-[5%]">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[2rem] w-full">
          {features.map((feature) => {
            const Logo = featureLogos[feature.type];
            return (
              <div
                key={feature.type}
                className={`rounded-lg overflow-hidden w-full ${
                  isRTL ? 'text-right' : ''
                } transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-lg`}
                data-aos="fade-up"
              >
                <div className="p-[1.5rem] text-white h-full" style={{ backgroundColor: '#63A7FB' }}>
                  <div className={`flex ${isRTL ? 'flex-row-reverse' : ''} justify-between items-center`}>
                    <h3 className="text-[1.25rem] font-bold uppercase">
                      {feature.title[currentLanguage]}
                    </h3>
                    <div className="text-white">
                      <Logo />
                    </div>
                  </div>
                  <p className="mt-[1rem] text-[1rem] sm:text-[1.125rem]">
                    {feature.description[currentLanguage]}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}